import dayjs from 'dayjs'
import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { activateOptionSelector } from '../../../../../modules/option-selector/index.js'
import { consolidationOrg } from './compute/special-entities.js'

export function showSelectors (changeAction, context) {
  console.log('showSelectors', context)

  const optionSelectorShow = [
    'dates',
    'others'
  ]

  const dateSeriesStart = context.browserAppAccount?.data?.firstLedgerDate || dayjs().subtract(48, 'months').format('YYYY-MM-DD')
  const dateseries = makeDateSeries(dateSeriesStart)

  const optionSelectorData = activateOptionSelector({
    containerId: 'optionSelector',
    show: optionSelectorShow,
    hide: [],
    default: 'organisations',
    onChange: changeAction,
    dateseries,
    dateOptions: {
      default: {
        from: 'relative:-5',
        to: 'relative:0'
      }
    },
    customSettings: {
      organisations: mapOrganisations(context),
      orgOptions: {
        // allowConso: true,
        enableConsolidation: consolidationOrg,
        allowMultiple: false,
        allowSeveral: true
        // defaultIndex: 0
      },
      currencies: context.browserAppAccount.data.currenciesForAccount
    }
  })

  return optionSelectorData
}

function mapOrganisations (context) {
  if (context.specificOrgId) return forNoAccount(context)

  const entities = context.browserAppAccount.data.entities
  entities.sort((a, b) => a.name.localeCompare(b.name))

  return entities
}

/** Allowing the page to be loaded for a specific entity, without a specific account */
function forNoAccount (context) {
  return [{
    _id: context.specificOrgId,
    name: context.specificOrgId
  }]
}
